import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Pagination_Holder from "../../../../../../common/common_components/pagination_holder/Pagination_Holder";

const Complaint_Report_Table = ({ setEdit }) => {
  const data = [
    {
      date: "01 Jan 2025",
      sampleId: "SAMP101",
      customerName: "Oashin Kawale",
      customerId: "CUST ID 1234",
      contactNo: "1234567891",
      complaintNature: "Deficiency In Service",
      remark: "",
      status: "Pending",
    },
    {
      date: "02 Jan 2025",
      sampleId: "SAMP102",
      customerName: "Prathamesh Raut",
      customerId: "CUST ID 1234",
      contactNo: "1234567891",
      complaintNature: "Restrictive Trade Practice (RTP)",
      remark: "",
      status: "Action Taken Report (ATR) Received",
    },
    {
      date: "03 Jan 2025",
      sampleId: "SAMP103",
      customerName: "Sonu Buradkaar",
      customerId: "CUST ID 1234",
      contactNo: "1234567891",
      complaintNature: "Deficiency In Service",
      remark: "",
      status: "Pending",
    },
    {
      date: "04 Jan 2025",
      sampleId: "SAMP104",
      customerName: "Paresh M.",
      customerId: "CUST ID 1234",
      contactNo: "1234567891",
      complaintNature: "Restrictive Trade Practice (RTP)",
      remark: "",
      status: "Action Taken Report (ATR) Received",
    },
    {
      date: "05 Jan 2025",
      sampleId: "SAMP105",
      customerName: "Aditya Jagtap",
      customerId: "CUST ID 1234",
      contactNo: "1234567891",
      complaintNature: "Deficiency In Service",
      remark: "",
      status: "Action Taken Report (ATR) Received",
    },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(data.length / itemsPerPage);

  const paginatedData = data.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="common_table_container theme_bg">
        <div className="table-responsive">
          <table className="common_table table table-striped">
            <thead>
              <tr>
                <th>
                  <input type="checkbox" />
                </th>
                <th>Date</th>
                <th>Sample ID</th>
                <th>Customer Name</th>
                <th>Customer ID</th>
                <th>Contact No.</th>
                <th>Nature Of Complaint</th>
                <th>Remark</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.map((row, index) => (
                <tr key={index} className={index % 2 !== 0 ? "striped" : ""}>
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td>{row.date}</td>
                  <td>{row.sampleId}</td>
                  <td>{row.customerName}</td>
                  <td>{row.customerId}</td>
                  <td>{row.contactNo}</td>
                  <td>{row.complaintNature}</td>
                  <td>{row.remark}</td>
                  <td>{row.status}</td>
                  <td>
                    <div
                      className="edit_icon_holder"
                      onClick={() => {
                        setEdit(true);
                      }}
                    >
                      <FontAwesomeIcon icon={faPencil} className="edit_icon" />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="comon_page_footer">
        <div className="show_entry_div">
          <p className="show_text">Showing 1 To 16 Of 16 Entries</p>
        </div>

        <div className="pagination_div">
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default Complaint_Report_Table;
